import React, { useEffect, useState } from "react";
import StepData from "../Helpers/StepData.json";
import { Button } from "react-bootstrap";
import Aos from "aos";

const Stepper = () => {
  const [activeStep, setActiveStep] = useState(0);
  //   const steps = [
  //     {
  //       title: "Build a campaign",
  //       content: (
  //         <div>
  //           <iframe
  //             width="560"
  //             height="315"
  //             src="https://www.youtube.com/embed/dQw4w9WgXcQ"
  //             title="YouTube video player"
  //             frameBorder="0"
  //             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  //             allowFullScreen
  //           ></iframe>
  //           <h3>Build a campaign</h3>
  //           <p>
  //             Build a channel-specific campaign and once it's live, you'll be able
  //             to invite any creators to participate. Additionally, over 175,000
  //             creators in our community will have the option to opt-in if they're
  //             interested!
  //           </p>
  //           <button>Try Now</button>
  //         </div>
  //       ),
  //     },
  //     {
  //       title: "Identify the right Creators",
  //       content: (
  //         <div>
  //           <h3>Identify the right Creators</h3>
  //           <p>Content for Step 2</p>
  //         </div>
  //       ),
  //     },
  //     {
  //       title: "Start collaborating",
  //       content: (
  //         <div>
  //           <h3>Start collaborating</h3>
  //           <p>Content for Step 3</p>
  //         </div>
  //       ),
  //     },
  //     {
  //       title: "Drive long-term success",
  //       content: {
  //         abc: "Content for Step 4",
  //       },
  //     },
  //   ];
  const handleStepClick = (index) => {
    setActiveStep(index);
  };
  useEffect(() => {
    Aos.init({});
  }, []);
  return (
    <div>
      <div className="stepper-container">
        <div className="stepper">
          {StepData.map((step, index) => (
            <React.Fragment key={index}>
              <div
                className={`step ${index === activeStep ? "active" : ""}`}
                onClick={() => handleStepClick(index)}
              >
                <div className="step-number">{index + 1}</div>
                <p>{step.title}</p>
              </div>
              {index < StepData.length - 1 && <div className="line"></div>}
            </React.Fragment>
          ))}
        </div>
        <div className="step-content-wrapper">
          <div
            className="video-box"
            data-aos="fade-up"
            data-aos-duration="1500"
          >
            <iframe
              width="100%"
              height="315"
              src={
                StepData[activeStep] && StepData[activeStep].content.youtubeLink
              }
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <div className="content-box">
            <h5 data-aos="fade-up" data-aos-duration="1500">
              {StepData[activeStep] && StepData[activeStep].title}
            </h5>
            <p data-aos="fade-up" data-aos-duration="1800">
              {StepData[activeStep] && StepData[activeStep].content.desc}
            </p>
            <Button data-aos="fade-up" data-aos-duration="2000">
              {StepData[activeStep] && StepData[activeStep].content.btnText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stepper;
